/**
 * Schedule days (client view) – list days in date range.
 */
import { collection, query, where, orderBy, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'scheduleDays';

export async function listByClientSchedule(clientScheduleId, clientId, fromDate, toDate) {
  if (!clientScheduleId || !clientId) throw new Error('clientScheduleId and clientId are required');
  const q = query(
    collection(db, COLLECTION),
    where('clientId', '==', clientId),
    where('clientScheduleId', '==', clientScheduleId),
    where('date', '>=', fromDate),
    where('date', '<=', toDate),
    orderBy('date', 'asc'),
    limit(62)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export const scheduleDayRepo = { listByClientSchedule };
